export default __webpack_public_path__ + "static/media/logo_wide.3747e968.jpg";